import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
	const isEmbedded = ref(false)
	const isIdle = ref(false)

	return {
		isEmbedded,
		isIdle
	}
})
